/**
 * Window utilities using the ponyfill
 */
import { windowPonyfill } from './window-ponyfill'

export const BREAKPOINTS = {
  MOBILE: 1024,
  TABLET: 768,
  DESKTOP: 1440,
} as const

export const isMobileBreakpoint = (): boolean =>
  windowPonyfill.innerWidth < BREAKPOINTS.MOBILE

export const confirmDialog = (message: string): boolean =>
  windowPonyfill.confirm(message)

export const getInnerWidth = (): number => windowPonyfill.innerWidth
